import { render, staticRenderFns } from "./WoDe.vue?vue&type=template&id=2cf3f252&scoped=true"
import script from "./WoDe.vue?vue&type=script&lang=js"
export * from "./WoDe.vue?vue&type=script&lang=js"
import style0 from "./WoDe.vue?vue&type=style&index=0&id=2cf3f252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3f252",
  null
  
)

export default component.exports